exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-shop-products .search-trigger{cursor:pointer;text-decoration:underline}@media screen and (min-width:600px){.page-shop-products .search-trigger.mobile-trigger{display:none}}.page-shop-products .search-trigger.desktop-trigger{display:none}@media screen and (min-width:600px){.page-shop-products .search-trigger.desktop-trigger{display:inline}}", ""]);

// exports
